import { clear, h } from '../core/dom'
import { haptic } from '../core/haptics'
import { go } from '../core/router'
import { getNight, getSettings, nightCount } from '../core/store'
import { t } from '../i18n'
import { clockString, tile } from './shared'

function greeting(hour: number): string {
  const d = t().home
  if (hour >= 2 && hour < 5) return d.greetingDeepNight
  if (hour >= 22 || hour < 2) return d.greetingNight
  if (hour >= 19) return d.greetingEvening
  if (hour >= 5 && hour < 11) return d.greetingMorning
  return d.greetingDay
}

export function renderHome(root: HTMLElement, signal: AbortSignal): void {
  const paint = (): void => {
    clear(root)
    const d = t()
    const now = new Date()
    const hour = now.getHours()
    const nights = nightCount()
    const night = getNight()

    // Between 1am and 5am the rescue button moves above the ritual list. At that
    // hour nobody is choosing a bedtime routine — they are already awake and
    // frightened, and the thing they need should be the first thing they touch.
    const deepNight = hour >= 1 && hour < 5

    const hero = h(
      'section',
      { class: 'hero stack-sm' },
      h('div', { class: 'clock' }, clockString(now)),
      h('div', { class: 'greeting' }, greeting(hour)),
      h('div', { class: 'faint' }, nights ? d.home.nightsLogged(nights) : d.home.nothingYet),
    )

    const rescue = h(
      'button',
      {
        class: 'rescue-btn',
        onclick: () => {
          haptic.soft()
          go('night3am')
        },
      },
      h('span', { class: 'big' }, d.home.rescue),
      h('span', { class: 'sub' }, d.home.rescueSub),
    )

    const done = (id: string): string => (night.ritualsDone.includes(id) ? '✓ ' : '')

    const ritual = h(
      'section',
      { class: 'stack' },
      h(
        'div',
        { class: 'between' },
        h('div', { class: 'section-label' }, d.home.ritual),
        h('div', { class: 'faint' }, d.home.ritualSub),
      ),
      h(
        'div',
        { class: 'stack-sm' },
        tile('◐', done('breath') + d.home.breath, d.home.breathSub, () => go('breath')),
        tile('❝', done('mantra') + d.home.mantra, d.home.mantraSub, () => go('mantra')),
        tile('✦', done('drift') + d.home.drift, d.home.driftSub, () => go('drift')),
        tile('≈', done('sound') + d.home.sound, d.home.soundSub, () => go('sound')),
      ),
    )

    const mini = h(
      'nav',
      { class: 'mini-row' },
      ...(
        [
          ['💬', d.home.companion, 'companion'],
          ['📖', d.home.ledger, 'ledger'],
          ['☀️', d.home.checkin, 'checkin'],
          ['⚙︎', d.home.settings, 'settings'],
        ] as const
      ).map(([glyph, label, route]) =>
        h(
          'button',
          {
            class: 'mini',
            onclick: () => {
              haptic.tap()
              go(route)
            },
          },
          h('span', {}, glyph),
          h('span', {}, label),
        ),
      ),
    )

    root.append(
      hero,
      h('div', { style: { height: '18px' } }),
      ...(deepNight ? [rescue, h('div', { style: { height: '22px' } }), ritual] : [ritual, h('div', { style: { height: '22px' } }), rescue]),
      h('div', { class: 'spacer' }),
      mini,
    )
  }

  paint()

  // The clock and the greeting drive the layout, so repaint on the minute.
  const timer = window.setInterval(paint, 30_000)
  signal.addEventListener('abort', () => clearInterval(timer), { once: true })

  // First run always goes through onboarding.
  if (!getSettings().onboarded) go('onboarding')
}
